import { css } from "@linaria/core";

import * as buttonStyles from "./atom.button.style";

export const modifiers = {
  noImage: css``,
  accent: css``,
};

export const wrapper = css`
  height: 100%;

  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  border-radius: 4px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-decoration: none;
  color: inherit;

  transition: box-shadow 75ms linear;

  &:hover {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);

    & .${buttonStyles.button} {
      background-color: rgb(9 11 25);
      color: rgb(255 255 255);

      &.${buttonStyles.accentTheme} {
        background: rgb(58, 105, 0);
        color: rgb(255 255 255);
      }
    }
  }

  &[data-color-variant="type-1"] {
    background: rgb(247 247 247);
  }

  &[data-color-variant="type-2"] {
    background: rgb(247 247 247);
  }

  &[data-color-variant="type-3"] {
    background: rgb(247 247 247);
  }

  @media (max-width: 767px) {
    box-sizing: border-box;
    width: 100%;

    flex-direction: row;
    align-items: flex-start;
  }
`;

export const image = css`
  margin-bottom: 10px;

  width: 100%;

  background-color: transparent !important;
  border-radius: inherit;

  & img {
    height: 100%;
    width: 100%;

    border-radius: inherit;

    object-fit: cover;
  }

  @media (max-width: 767px) {
    margin: 0 8px 0 0;
    padding: 10px;

    box-sizing: border-box;
    height: 100px;
    width: 100px;

    flex-shrink: 0;
  }
`;

export const textWrapper = css`
  padding-inline: 20px;

  box-sizing: border-box;
  width: 100%;

  display: flex;
  flex-direction: column;
  text-align: center;

  @media (min-width: 768px) and (max-width: 1023px) {
    padding-inline: 16px;
  }

  @media (max-width: 767px) {
    padding: 15px 15px 15px 0;

    gap: 10px;
    text-align: left;

    .${modifiers.noImage} & {
      margin-left: 25px;
    }
  }
`;

export const heading = css`
  margin-top: 0;
  margin-bottom: 15px;

  hyphens: auto;

  font-weight: bold;
  font-size: 28px;
  line-height: 1.14;

  .${modifiers.noImage} & {
    margin-top: 50px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 24px;
    line-height: 1.2;
  }

  @media (max-width: 767px) {
    margin: 0;
    font-weight: bold;
    font-size: 20px;
    line-height: 1.15;

    .${modifiers.noImage} & {
      margin-top: 0;
    }
  }
`;

export const description = css`
  margin: 0;
  font-size: 18px;
  line-height: 1.5;

  @media (max-width: 1023px) {
    font-size: 14px;
    line-height: 1.35;
  }
`;
